require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./weihnachtliche-neuigkeiten-von-der-baustelle.json") })
        }
      }, "path---weihnachtliche-neuigkeiten-von-der-baustelle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---weihnachtliche-neuigkeiten-von-der-baustelle!./.cache/json/weihnachtliche-neuigkeiten-von-der-baustelle.json
// module id = 435
// module chunks = 231608221292675